export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mostrado:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["total"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Por página"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mostrar"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resultados"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["de"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intercambio"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intercambios"])}
}